import ApplicationController from './application_controller'
import { createPopper } from '@popperjs/core';
import * as bootstrap from 'bootstrap';

export default class extends ApplicationController {

  static targets = [ "trigger", "tooltip" ]

  connect () {
    super.connect()

    if(this.triggerTargets !== undefined) {
      this.triggerTargets.forEach((triggerTarget) => {
        triggerTarget.setAttribute("data-bs-html", true);
        new bootstrap.Tooltip(triggerTarget);
      });
    }
  }
}
